import {
    ps_order_search,
    update_ps_order,
    status_tracking_ps_order,
    status_sms_ps_order,
    product_review_request_ps_order
} from "../../api/orders.api"
import Vue from 'vue'

const getDefaultState = () => {
    return {
        orders: []
    }
}

// initial state
const state = getDefaultState()


const mutations = {
    /*set_ps_orders(state, ps_orders) {
        console.info("ORDER START loading")
        state.orders = ps_orders
        console.info("ORDER START loading done")
    },

    add_ps_order(state, ps_order) {
        state.orders = [ps_order, ...state.orders]
    },*/

    resetState (state) {
        Object.assign(state, getDefaultState())
    },

    update_ps_order(state, payload) {

        const index = state.orders.findIndex(order => order.id_order === payload.ps_order.id_order);

        if(index >= 0) {
            Vue.set(state.orders, index, payload.ps_order);
        }else{
            if(payload.beginning)
                state.orders.unshift(payload.ps_order)
            else
                state.orders.push(payload.ps_order)
        }

    }
}

const actions = {

    ps_order_product_review_request({state, commit}, order) {
        return new Promise((resolve, reject) =>
            product_review_request_ps_order(order)
                .then((response) => {
                    if (response.status == '200') {
                        resolve(response)
                    }
                })
                .catch(error => {
                    reject(error)
                })
        )
    },

    ps_order_search({state, commit}, searchString) {
        return new Promise((resolve, reject) =>
            ps_order_search(searchString)
                .then((response) => {
                    if (response.status == '200') {
                        resolve(response)
                    }
                })
                .catch(error => {
                    reject(error)
                })
        )
    },

    ps_order_update({state, commit}, order) {

        // On met à jour la base
        return new Promise((resolve, reject) =>
            update_ps_order(order)
                .then((response) => {
                    if (response.status == '200') {
                        resolve(response)
                    }
                })
                .catch(error => {
                    reject(error)
                })
        )
    },
    ps_order_status_tracking({state, commit}, order) {

        // On met à jour la base
        return new Promise((resolve, reject) =>
            status_tracking_ps_order(order)
                .then((response) => {
                    if (response.status == '200') {
                        resolve(response)
                    }
                })
                .catch(error => {
                    reject(error)
                })
        )
    },

    ps_order_status_sms({state, commit}, reference) {

        // On met à jour la base
        return new Promise((resolve, reject) =>
            status_sms_ps_order(reference)
                .then((response) => {
                    if (response.status == '200') {
                        resolve(response)
                    }
                })
                .catch(error => {
                    reject(error)
                })
        )
    },

    /*get_ps_orders(context) {
        return new Promise((resolve, reject) =>
            ps_orders()
                .then((response) => {
                    if (response.status == '200') {
                        let ps_orders = response.data;
                        context.commit('set_ps_orders', ps_orders)
                    }
                })
                .catch(error => {
                })
        )
    },*/

    archiveOrder({dispatch, state, commit}, order)
    {
        order.archived = 1;
        dispatch('ps_order_update', order)
    }
}

const getters = {
    orders(state) {
        return state.orders
    },

    orders_by_reference:(state => (reference) => {
        return state.orders.filter(item => item.reference === reference)
    })
}


export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}
